import React from 'react';
import {
    ServiceP,
    ServicesCard,
    ServicesContainer,
    ServicesH1,
    ServicesH2,
    ThreeWrapper, WhiteH1
} from "./FormsElements";
import {
    CardYoutubeWrap,
    InfoContainer
} from "../InfoSection/InfoElements";

const FormsACADetails = () => {
    return (
        <>
        <ServicesContainer id='formsaca'>
            <ServicesH1>ACA Forms</ServicesH1>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>Form 1095-B</ServicesH2>
                    <ServiceP>ACA Health Coverage</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 1095-C</ServicesH2>
                    <ServiceP>Employer-Provided Health Insurance Offer and Coverage
                    </ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 1094-B</ServicesH2>
                    <ServiceP>Transmittal of Health Coverage Information Returns</ServiceP>
                </ServicesCard>
            </ThreeWrapper>
        </ServicesContainer>
            <InfoContainer lightBg={false} >
                <ServicesContainer>
                    <WhiteH1>How to E-file ACA Form Online</WhiteH1>
                    <CardYoutubeWrap>
                        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/OiByE_cMoeo" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    </CardYoutubeWrap>
                </ServicesContainer>
            </InfoContainer>
        </>
    );
};

export default FormsACADetails;
